import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import Isvg from 'react-inlinesvg';

import { bem } from 'helpers/class-name';
import { ICONS } from 'constants/icons';
import appMessages from 'features/App/App.messages';

import { TOPIC_IDS } from './HowSmartRateWorks.constants';
import AdjustsCreditsPanel from './AdjustsCreditsPanel';
import GuaranteedMinimumPanel from './GuaranteedMinimumPanel';
import MaximizesRevenuePanel from './MaximizesRevenuePanel';

import './SmartRateTopicPanel.scss';

const { block, element } = bem('smart-rate-topic-panel');

const TOPIC_PANELS = {
  [TOPIC_IDS.GUARANTEED_MINIMUM]: GuaranteedMinimumPanel,
  [TOPIC_IDS.ADJUSTS_CREDITS]: AdjustsCreditsPanel,
  [TOPIC_IDS.MAXIMIZES_REVENUE]: MaximizesRevenuePanel,
};

const SmartRateTopicPanel = ({ labelledBy, onClose, panelId, showCloseButton, topicId }) => {
  const intl = useIntl();
  const TopicContent = TOPIC_PANELS[topicId];

  return (
    <div
      className={block({ 'has-close-button': showCloseButton })}
      id={panelId}
      {...(labelledBy ? { 'aria-labelledby': labelledBy, role: 'tabpanel' } : {})}>
      {showCloseButton && (
        <button
          aria-label={intl.formatMessage(appMessages.close)}
          className={element('close-button')}
          onClick={onClose}
          type="button">
          <Isvg aria-hidden src={ICONS.cross} />
        </button>
      )}
      <div className={element('content')}>{TopicContent ? <TopicContent /> : null}</div>
    </div>
  );
};

SmartRateTopicPanel.defaultProps = {
  showCloseButton: true,
};

SmartRateTopicPanel.propTypes = {
  labelledBy: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  panelId: PropTypes.string.isRequired,
  showCloseButton: PropTypes.bool,
  topicId: PropTypes.string.isRequired,
};

export default SmartRateTopicPanel;
